import type { OtherAsset } from "~/types/assets.types";

export const otherExpectedYield = (userProudct: OtherAsset) =>
  userProudct?.predictedValueIncrease || 0;
